// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentMain {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 77px 16px 110px 16px;
}

.paymentContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #FFF4D9;
    padding: 30px 18px 13px 18px;
    position: relative;
    z-index: 99;
    border-radius: 16px;
    gap: 9px;
    min-height: calc(100vh - 180px);
    justify-content: space-between;
}

.paymentTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: left;
    color: rgba(75, 45, 16, 1);
    margin-left: 16px;
}

.paymentColumn {
    display: flex;
    flex-direction: column;
    gap: 37px;
    width: 100%;
}

.paymentPromotionBlock {
    padding: 10px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 232, 174, 1);
    border-radius: 16px;
}

.paymentPromotionText {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-align: justified;
    color: rgba(142, 59, 0, 1);
}

.paymentButton {
    border: none;
    background: rgba(255, 107, 0, 1);
    height: 36px;
    border-radius: 8px;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    color: rgba(255, 228, 208, 1);
    width: 100%;
}

.paymentBlockCards {
    display: flex;
    flex-direction: column;
    background: rgba(255, 232, 174, 1);
    gap: 9px;
    padding: 15px 8px;
    border-radius: 16px;
}

.paymentBlockCardsTitle {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    color: rgba(142, 59, 0, 1);
}

.paymentCardColumn {
    display: flex;
    flex-direction: column;
    gap: 9px;
    width: 100%;
}

.paymentCardHr {
    width: 100%;
    border: none;
    border-top: solid 1px rgba(187, 141, 108, 1);
}

.paymentCardLine {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Payment/Payment.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".paymentMain {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 77px 16px 110px 16px;\n}\n\n.paymentContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #FFF4D9;\n    padding: 30px 18px 13px 18px;\n    position: relative;\n    z-index: 99;\n    border-radius: 16px;\n    gap: 9px;\n    min-height: calc(100vh - 180px);\n    justify-content: space-between;\n}\n\n.paymentTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: left;\n    color: rgba(75, 45, 16, 1);\n    margin-left: 16px;\n}\n\n.paymentColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 37px;\n    width: 100%;\n}\n\n.paymentPromotionBlock {\n    padding: 10px 8px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    background: rgba(255, 232, 174, 1);\n    border-radius: 16px;\n}\n\n.paymentPromotionText {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: justified;\n    color: rgba(142, 59, 0, 1);\n}\n\n.paymentButton {\n    border: none;\n    background: rgba(255, 107, 0, 1);\n    height: 36px;\n    border-radius: 8px;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: center;\n    color: rgba(255, 228, 208, 1);\n    width: 100%;\n}\n\n.paymentBlockCards {\n    display: flex;\n    flex-direction: column;\n    background: rgba(255, 232, 174, 1);\n    gap: 9px;\n    padding: 15px 8px;\n    border-radius: 16px;\n}\n\n.paymentBlockCardsTitle {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 24px;\n    color: rgba(142, 59, 0, 1);\n}\n\n.paymentCardColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    width: 100%;\n}\n\n.paymentCardHr {\n    width: 100%;\n    border: none;\n    border-top: solid 1px rgba(187, 141, 108, 1);\n}\n\n.paymentCardLine {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
